import { ArrowUpRight, Wifi, MapPin } from "lucide-react";
import { SUBJECTS } from "@/data/content";

export const Subjects = () => {
  return (
    <section id="subjects" className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-testid="subjects-section">
      <div className="max-w-2xl">
        <p className="eyebrow-label" data-testid="subjects-eyebrow">What we tutor</p>
        <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl" data-testid="subjects-heading">
          Subjects, taught the <span className="text-secondary">practical</span> way.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
          Not just theory. Our tutors bring the necessary experience and relevant qualifications in their subjects —
          and teach the way BSA has always taught: hands-on, clear and connected to real work.
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-12" data-testid="subjects-grid">
        {SUBJECTS.map((s, i) => (
          <article
            key={s.id}
            className={`group overflow-hidden rounded-2xl border border-border bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${
              i === 0 ? "md:col-span-7" : i === 1 ? "md:col-span-5" : i === 2 ? "md:col-span-5" : "md:col-span-7"
            }`}
            data-testid={`subject-card-${s.id}`}
          >
            <div className="relative h-52 overflow-hidden sm:h-60">
              <img
                src={s.image}
                alt={s.alt}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B3B60]/80 via-transparent to-transparent" />
              <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 font-heading text-xs font-bold text-primary backdrop-blur">
                {s.grades}
              </span>
              <div className="absolute bottom-4 left-4 flex gap-2">
                <span className="flex items-center gap-1 rounded-full bg-white/15 px-2.5 py-1 text-[11px] font-bold text-white backdrop-blur">
                  <Wifi className="h-3 w-3" /> Online
                </span>
                <span className="flex items-center gap-1 rounded-full bg-white/15 px-2.5 py-1 text-[11px] font-bold text-white backdrop-blur">
                  <MapPin className="h-3 w-3" /> In person
                </span>
              </div>
            </div>
            <div className="p-7 sm:p-8">
              <h3 className="font-heading text-xl font-bold text-slate-900 sm:text-2xl">{s.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base">{s.blurb}</p>
              <ul className="mt-4 space-y-2">
                {s.points.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-sm font-medium text-slate-700">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-amber-500" />
                    {p}
                  </li>
                ))}
              </ul>
              <a
                href="#book"
                className="mt-6 inline-flex items-center gap-1 font-heading text-sm font-bold text-secondary transition-colors duration-200 hover:text-primary"
                data-testid={`subject-book-link-${s.id}`}
              >
                Book {s.name} <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
